export default __webpack_public_path__ + "9792ef01a105ae182af963a43fddc483.png";